import authService from "src/helpers/authService";
import { User } from "src/store/User";

export const RouteName = {
  main: "report-builder",
} as const;

export function authZ_hasSomeRoutePermission() : boolean {
  return authService(User.value.roles ?? [], "registrar", "webmaster")
    || !!User.userData?.competitionsMemento.find(v => v.isPlayerAdmin)
    || !!User.userData?.divisionsMemento.find(v => v.writeAccess)
}
